"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
class Address {
    constructor(obj) {
        this.city = obj.city;
        this.number = obj.number;
        this.street = obj.street;
        this.zipCode = obj.zipCode;
    }
    get isValid() {
        return Boolean(this.street) && Boolean(this.number) && Boolean(this.zipCode) && Boolean(this.city);
    }
    /**
     * Return formatted address. even if fields are missing
     */
    formatted() {
        const firstPart = "" + (this.street ? this.street + " " : "") + (this.number ? this.number : "");
        const secondPart = "" + (this.zipCode ? this.zipCode + " " : "") + (this.city || "");
        if (firstPart && secondPart) {
            return `${firstPart}, ${secondPart}`;
        }
        else if (firstPart) {
            return firstPart.trim();
        }
        else if (secondPart) {
            return secondPart.trim();
        }
        else {
            return "";
        }
    }
    getGoogleMapsLink() {
        const encoded = encodeURI(`${this.street} ${this.number}, ${this.zipCode} ${this.city}`);
        return `https://maps.google.com/?q=${encoded}`;
    }
}
exports.Address = Address;
//# sourceMappingURL=address.js.map